import React, { createContext, useContext, useMemo, useState } from 'react';
import {
  SupportChatDetailsOutput,
  useGetSupportChatDetailQuery,
} from 'graphql/generated/hasura';
import { v4 as uuid } from 'uuid';

type SupportChatContextValue = {
  chat?: SupportChatDetailsOutput | null;
  chatId: string;
  loading: boolean;
};

const SupportChatContext = createContext<SupportChatContextValue | null>(null);

export const SupportChatProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { data, loading } = useGetSupportChatDetailQuery();
  const chat = data?.getSupportChatDetail;

  const [temporaryId] = useState<string>(() => uuid());

  const serverId = chat?.id;
  const chatId = serverId ?? temporaryId;

  const value = useMemo(
    () => ({
      chatId,
      chat,
      loading,
    }),
    [chatId, chat, loading],
  );

  return (
    <SupportChatContext.Provider value={value}>
      {children}
    </SupportChatContext.Provider>
  );
};

export const useSupportChat = (): SupportChatContextValue => {
  const context = useContext(SupportChatContext);
  if (!context) {
    throw new Error('useSupportChat must be used within a SupportChatProvider');
  }
  return context;
};
